import { Component, inject } from '@angular/core';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';
import { RouterLink } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-mobile-buttons',
  imports: [SvgIconComponent, RouterLink],
  templateUrl: './mobile-buttons.component.html',
})
export class MobileButtonsComponent {
  private scroller = inject(ViewportScroller);

  scrollToElement(id: string) {
    this.scroller.scrollToAnchor(id);
  }
}
